import useSitecoreStore from '@/stores/sitecore';
import { useHead, useSeoMeta } from '@unhead/vue';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const useSeoTags = () => {
    const store = useSitecoreStore();
    const { languageCode, siteName, routing } = storeToRefs(store);
    const title = computed(() => routing.value.data?.fields?.title.value);
    const titleTemplate = computed(() =>
        routing.value.data?.fields?.displaySiteName.value ? `%s - ${siteName.value}` : ''
    );
    const description = computed(() => routing.value.data?.fields?.description.value);
    const image = computed(() => routing.value.data?.fields?.image?.value.src);
    const url = computed(() => routing.value.data?.routeUrl);

    useHead({
        htmlAttrs: {
            lang: languageCode
        }
    });

    useSeoMeta({
        title,
        titleTemplate,
        description,
        ogTitle: title,
        ogDescription: description,
        ogImage: image,
        ogUrl: url,
        ogSiteName: siteName
    });
};

export default useSeoTags;
